module.exports = __webpack_public_path__ + "76bca39ed5aaf34ed5ccdddec9bcfa57.png";